import { render, staticRenderFns } from "./YedeerLayout.vue?vue&type=template&id=47adabb4&scoped=true&"
import script from "./YedeerLayout.vue?vue&type=script&lang=js&"
export * from "./YedeerLayout.vue?vue&type=script&lang=js&"
import style0 from "./YedeerLayout.vue?vue&type=style&index=0&id=47adabb4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47adabb4",
  null
  
)

export default component.exports